import { Skeleton } from 'antd';
import './HomePlanProfileSkeleton.scss';

const HomePlanProfileSkeleton = ({ workspacePage = false }) => {
  return (
    <div
      className={`home-profile d-flex align-items-stretch ${
        workspacePage ? 'px-4 w-100 b-radius-8 bg-white' : 'w-100 px-4'
      }`}
    >
      <div
        className={`d-flex flex-row ${
          workspacePage ? 'px-2 w-100 workspace-profile-content' : 'gap-2 w-100'
        }`}
      >
        <div className="d-flex align-items-center">
          <Skeleton.Avatar
            active
            shape="circle"
            className="home-plan-image"
          />
        </div>
        <div
          className={`d-flex w-100 ${
            workspacePage
              ? 'flex-row  align-items-center justify-content-between'
              : 'justify-content-between flex-column w-100'
          }`}
          style={{ minHeight: '100%' }}
        >
          <span
            className={`font-weight-700  text-title ${
              workspacePage ? 'position-profile-name' : ''
            }`}
          >
            <Skeleton.Input active className="skeleton-plan-title" />
          </span>
          <div
            className={`d-flex gap-1 mt-auto ${
              workspacePage
                ? 'button-create-workspace w-50 align-items-center justify-self-end'
                : 'w-100 flex-column'
            }`}
          >
            <div className={`${workspacePage ? 'position-progress-bar w-100' : 'w-100'}`}>
              <Skeleton.Input active className="skeleton-credits-text mb-1" />
              <Skeleton.Input active className="skeleton-renewal-text" />
              <div className="skeleton-progress-container">
                <Skeleton.Button active className="skeleton-progress-bar" block />
              </div>
            </div>
            <div
              className={`d-flex ${
                workspacePage ? 'w-50' : 'flex-column flex-md-row gap-1 home-profile-content w-100'
              } justify-content-end`}
            >
              <Skeleton.Button active className={`skeleton-plan-button ${workspacePage ? '' : 'home-plan-button'}`} />
              <Skeleton.Button active className={`skeleton-recommend-button ${workspacePage ? 'ml-2' : 'home-plan-button-recommended'}`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePlanProfileSkeleton;
